<div class="kt-portlet"
	 [ngClass]="{ 'kt-portlet--body-progress kt-portlet--body-progress-overlay' : loading }">

	<div class="kt-portlet__head">
		<div class="kt-portlet__head-label">
					<span class="kt-portlet__head-icon">
						<mat-icon>lock</mat-icon>
					</span>
			<h3 class="kt-portlet__head-title">
				Se connecter
			</h3>
		</div>
	</div>

	<!--boday-->
	<div class="kt-portlet__body">

		<div *ngIf="msgErrors != ''" style="width:100%"
			 class="alert alert-solid-danger alert-bold fade show kt-margin-b-20" role="alert">
			<div class="alert-icon"><i class="fa fa-exclamation-triangle"></i></div>
			<div class="alert-text">{{msgErrors}}</div>
			<div class="alert-close">
				<button type="button" class="close" data-dismiss="alert" aria-label="Close">
					<span aria-hidden="true"><i class="la la-close"></i></span>
				</button>
			</div>
		</div>


		<!--begin::Form-->
		<form class="kt-form" [formGroup]="loginForm" autocomplete="off">
			<div class="form-group">
				<mat-form-field>
					<mat-label>Email</mat-label>
					<input matInput type="email" placeholder="Email" formControlName="email" autocomplete="off"/>
				</mat-form-field>
			</div>
			<div class="form-group">
				<mat-form-field>
					<mat-label>Mot de passe</mat-label>
					<input matInput type="password" placeholder="Mot de passe" formControlName="password" autocomplete="off"/>
				</mat-form-field>
			</div>
		</form>
		<!--end::Form-->

	</div>



	<!--footer-->
	<div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit">
		<div class="kt-form__actions kt-form__actions--solid">
			<div class="row text-right kt-padding-10">
				<div class="col-lg-12">
					<button type="button" mat-raised-button (click)="quitter()" cdkFocusInitial
							matTooltip="Annuler les modifications">
						Quitter
					</button>&nbsp;
					<button type="button" mat-raised-button color="primary" [disabled]="loading"
							matTooltip="Enregistrer les modifications" (click)="seconnecter()">
						<i *ngIf="loading" class="kt-spinner kt-spinner--brand"></i>
						Se connecter
					</button>
				</div>
			</div>
		</div>
	</div>


</div>







